import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TopBar } from './TopBar';
import { AuthGuard } from './AuthGuard';

interface LayoutProps {
  children: React.ReactNode;
}

const LayoutContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  width: '100%',
  backgroundColor: theme.palette.background.default,
}));

const MainContent = styled(Box)(({ theme }) => ({
  width: '100%',
  flex: 1,
  marginTop: 0,
  marginBottom: 0,
  paddingInline: theme.spacing(2),
  paddingBlock: theme.spacing(3),
  overflow: 'hidden',
  [theme.breakpoints.up('sm')]: {
    paddingInline: theme.spacing(3),
    paddingBlock: theme.spacing(4),
  },
  [theme.breakpoints.up('md')]: {
    paddingInline: theme.spacing(4),
    paddingBlock: theme.spacing(5),
  },
  [theme.breakpoints.up('lg')]: {
    paddingInline: theme.spacing(6),
  },
}));

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <AuthGuard>
      <LayoutContainer component="div" role="document">
        <Box component="header" role="banner">
          <TopBar />
        </Box>
        <MainContent component="main" id="main-content" role="main">
          {children}
        </MainContent>
      </LayoutContainer>
    </AuthGuard>
  );
};

